import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';
import {DealService} from "../service/deal.service";

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {

  constructor(public apiService: ApiService,
              public dealService: DealService) {
  }

  ngOnInit() {
  }

  totalDeals() {
    let count = 0;
    for (const group of this.dealService.getGroups()) {
      count += group.deals.length;
    }
    return count;
  }

  totalUniqDeals() {
    return this.dealService.getGroups().length;
  }

  totalInvested() {
    let sum = 0;
    for (const group of this.dealService.getGroups()) {
      sum += group.totalSum();
    }
    return sum;
  }

  totalProfitDeals() {
    let count = 0;
    for (const group of this.dealService.getGroups()) {
      for (const deal of group.deals) {
        if (deal.profit < 0) {
          continue;
        }
        count++;
      }
    }
    return count;
  }

  totalProfit() {
    let profit = 0;
    for (const group of this.dealService.getGroups()) {
      for (const deal of group.deals) {
        if (deal.profit < 0) {
          continue;
        }
        profit += deal.profit;
      }
    }
    return profit;
  }

  totalLossDeals() {
    let count = 0;
    for (const group of this.dealService.getGroups()) {
      for (const deal of group.deals) {
        if (deal.profit > 0) {
          continue;
        }
        count++;
      }
    }
    return count;
  }

  totalLoss() {
    let loss = 0;
    for (const group of this.dealService.getGroups()) {
      for (const deal of group.deals) {
        if (deal.profit > 0) {
          continue;
        }
        loss += Math.abs(deal.profit);
      }
    }
    return loss;
  }

  lastCreatedDeal() {
    let date = 0;
    for (const group of this.dealService.getGroups()) {
      for (const deal of group.deals) {
        if (deal.created > date) {
          date = deal.created;
        }
      }
    }
    return new Date(date);
  }
}
